import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'redux/reducers/settings';
import { Response } from 'common/types';

import { IPageQueryParams } from '../courses';
import { TraineeProfile } from 'pages/private/TraineeProfile';

export enum ITraineeStatus {
  'Accepted' = 1,
  'Pending' = 2,
  'Rejected' = 3
}

export interface IProvince {
  created_at: string;
  id: number;
  name_en: string;
  name_np: string;
  province_code: string;
  province_number: number;
  updated_at: string;
}

export interface IDistrict {
  id: number;
  name_en: string;
  name_np: string;
  province_id: number;
  row_total: number;
}

export interface DistrictResponse {
  code: number;
  message: string;
  data: {
    total_rows: number;
    districts: IDistrict[];
  };
}

export const geographyApi = createApi({
  reducerPath: 'geographyApi',
  baseQuery: baseQuery,
  tagTypes: ['Province', 'District'],
  endpoints: (build) => ({
    listProvince: build.query({
      query: () => `core/provinces/`,
      transformResponse: (res: { data: { provinces: IProvince[] } }) => res.data?.provinces,
      providesTags: (data) => {
        return data
          ? [
              ...data.map((r) => ({ type: 'Province' as const, id: r.id })),
              { type: 'Province', id: 'PARTIAL-LIST' }
            ]
          : [{ type: 'Province', id: 'PARTIAL-LIST' }];
      }
    }),
    listDistrictByProvince: build.query<
      { districts: IDistrict[]; totalRows: number },
      { provinceId: string; page: number }
    >({
      query: ({ provinceId, page }) => `core/districts/?provinceId=${provinceId}&page=${page}`,

      transformResponse: (response: DistrictResponse) => ({
        districts: response.data.districts,
        totalRows: response.data.total_rows
      }),

      keepUnusedDataFor: 0,

      providesTags: (result) => {
        return result
          ? [
              ...result.districts.map((r) => ({ type: 'District' as const, id: r.id })),
              { type: 'District', id: 'PARTIAL-LIST' }
            ]
          : [{ type: 'District', id: 'PARTIAL-LIST' }];
      }
    })
  })
});

export const { useListProvinceQuery, useListDistrictByProvinceQuery } = geographyApi;
